import React, { createContext, useContext } from "react";

/**
 * Provides an "annotation-edit pipeline" to descendant block renderers so
 * that LexicalTextEditor instances rendered in readOnly mode (e.g. on the
 * PublishedPage or DataPivot) can still mutate annotations and persist them
 * via /quickUpdateContent.
 *
 * Producers: hosts that want to expose annotation editing wrap their
 * subtree with <AnnotationEditPipelineContext.Provider value={pipeline}>.
 * The pipeline is the return value of useAnnotationEditPipeline.
 *
 * Consumers: ViewBlockGenerator + ContentBlock read this context to decide
 * whether to unlock annotation affordances and where to route saves.
 */
export const AnnotationEditPipelineContext = createContext(undefined);

export const useAnnotationEditPipelineContext = () =>
  useContext(AnnotationEditPipelineContext);
